import React, { useState } from 'react';
import VehicleActionsMenu from '../actions/VehicleActionsMenu';

const VehicleCard = ({ vehicles, handleEdit, handleDownload, onToggleStatus }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="grid gap-4 md:hidden">
        {vehicles.map((v, idx) => (
            <div key={idx} className="bg-white shadow border rounded p-4">
            <div className="flex justify-between">
                <div>
                <p className="font-semibold">{u(v.vehicle_number)}</p>
                <p className="text-sm text-gray-600">TYPE: {u(v.vehicle_type?.name)}</p>
                <p className="text-sm text-gray-600">CHASSIS: {u(v.chassis_number)}</p>
                <p className="text-xs text-gray-400">DIMENSION: {u(v.dimension?.dimension)}</p>
                <p
                  onClick={() => onToggleStatus(v)}
                  className="text-sm text-blue-600 cursor-pointer hover:underline mt-1"
                >
                  STATUS: {v.is_active ? 'ACTIVE' : 'INACTIVE'}
                </p>
                </div>
                <VehicleActionsMenu
                vehicle={v}
                onEdit={() => handleEdit(v)}
                onDownload={(type) => handleDownload(v, type)}
                />
            </div>
            </div>
        ))}
    </div>
  );
};

export default VehicleCard;
